export default __webpack_public_path__ + "static/media/caixa-mensagens-vazia.6ff6b424.png";